import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Breadcrumb from "../../../../../Components/Breadcrumb/Breadcrumb";
import Footer from "../../../Include/Footer";
import moment from "moment";
import { Pagination, Search } from "../../../Table";
import DropDown from "../../../../../Components/DropDown";
import { getViewPoItems } from "../../../../../Store/prosafe/proTransaction/PurOrder/getViewPoItems";

const ReadOnlyInput = ({ label, value }) => (
  <div className="col-12 col-md-4 col-xl-4">
    <div className="input-block local-forms custom-select-wpr">
      <label>{label}</label>
      <input className="form-control" value={value || "-"} readOnly />
    </div>
  </div>
);

const ViewPurOrder = () => {
  const dispatch = useDispatch();
  const { state: data } = useLocation();
  const navigate = useNavigate();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);

  useEffect(() => {
    if (data?._id) {
      dispatch(getViewPoItems({ formData: { id: data?._id } }));
    }
  }, [data]);

  const itemData = useSelector((state) => state?.getViewPoItems?.user?.data);

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    {
      label: "Purchase Order",
      link: "/main-store/user/purchase-order-management",
    },
    { label: "View Purchase Order", active: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = itemData?.items_details;
    if (search) {
      computedComments = computedComments.filter((fi) =>
        fi.item_name?.toLowerCase()?.includes(search?.toLowerCase())
      );
    }
    setTotalItems(computedComments?.length);
    return computedComments?.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [currentPage, search, limit, itemData]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const totals = useMemo(() => {
    return commentsData?.reduce(
      (acc, item) => {
        acc.quantity += Number(item.quantity) || 0;
        acc.amount += Number(item.amount) || 0;
        acc.total_amount += Number(item.total_amount) || 0;
        acc.rate += Number(item.rate) || 0;
        acc.discount_amount += Number(item.discount_amount) || 0;
        acc.taxable_amount += Number(item.taxable_amount) || 0;
        acc.gst_amount += Number(item.gst_amount) || 0;
        return acc;
      },
      {
        quantity: 0,
        amount: 0,
        total_amount: 0,
        rate: 0,
        discount_amount: 0,
        taxable_amount: 0,
        gst_amount: 0,
      }
    );
  }, [commentsData]);

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>View Purchase Request Details</h4>
                      </div>
                    </div>

                    <div className="row">
                      {/* <ReadOnlyInput
                        label="Project No"
                        value={data?.manual_pro_no}
                      /> */}
                      <ReadOnlyInput
                        label="Project"
                        value={`${data?.project_details?.name} ${data?.project_details?.project_no
                          ? `(${data?.project_details?.project_no} )`
                          : ""
                          } `}
                      />
                      <ReadOnlyInput
                        label="Party"
                        value={data?.party_details?.name}
                      />
                      <ReadOnlyInput label="PO No." value={data?.voucher_no} />
                      <ReadOnlyInput
                        label="PO Date"
                        value={moment(data?.trans_date).format("YYYY-MM-DD")}
                      />
                      <ReadOnlyInput
                        label="Quotation No"
                        value={data?.quotation_details?.voucher_no}
                      />
                      <ReadOnlyInput
                        label="Payment Method"
                        value={data?.payment_method_name}
                      />
                      <ReadOnlyInput
                        label="Ordered By"
                        value={data?.create_by?.name}
                      />
                      <ReadOnlyInput
                        label="Freight Amount (₹)"
                        value={data?.freight_amount}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="page-table-header mb-2 p-0">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Items List</h3>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form>
                                <Search
                                  onSearch={(value) => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                  }}
                                />
                                {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                <a className="btn">
                                  <img
                                    src="/assets/img/icons/search-normal.svg"
                                    alt="search"
                                  />
                                </a>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                        <DropDown
                          limit={limit}
                          onLimitChange={(val) => setlimit(val)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table border-0 custom-table comman-table mb-0">
                      <thead>
                        <tr>
                          <th>Sr.</th>
                          <th>Item No</th>
                          <th>Item Name</th>
                          {/* <th>Item Weight</th> */}
                          <th>PO Qty</th>
                          <th>Original Rate(₹)</th>
                          <th>Purchase Rate(₹)</th>
                          <th>Amount(₹)</th>
                          <th>Discount(%)</th>
                          <th>Discount Amount(₹)</th>
                          <th>Taxable Amount(₹)</th>
                          <th>GST (%)</th>
                          <th>GST Amount(₹)</th>
                          <th>Total Amount(₹)</th>
                          {/* <th>Item Length</th>
                          <th>Item Width</th> */}
                          {/* <th>Item Radius</th>
                          <th>Item Thickness</th>
                          <th>Assembly Weight</th>
                          <th>Surface Area</th> */}
                          <th>Remarks</th>
                          <th>Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {commentsData?.map((item, index) => (
                          <tr key={item._id || index}>
                            <td>{index + 1}</td>
                            <td>{item.item_no || "-"}</td>
                            <td>{item.item_name || "-"}</td>
                            {/* <td>{item.item_weight || "-"}</td> */}
                            <td>{item.quantity ?? "-"}</td>
                            <td>
                              {item.mrp ? Number(item.mrp).toFixed(2) : "-"}
                            </td>
                            <td>
                              {item.rate ? Number(item.rate).toFixed(2) : "-"}
                            </td>
                            <td>
                              {item.amount
                                ? Number(item.amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.discount
                                ? Number(item.discount)
                                : "-"}
                            </td>
                            <td>
                              {item.discount_amount
                                ? Number(item.discount_amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.taxable_amount
                                ? Number(item.taxable_amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.gst ? Number(item.gst) : "-"}
                            </td>
                            <td>
                              {item.gst_amount
                                ? Number(item.gst_amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.total_amount
                                ? Number(item.total_amount).toFixed(2)
                                : "-"}
                            </td>
                            {/* <td>{item.item_length || "-"}</td>
                            <td>{item.item_width || "-"}</td> */}
                            {/* <td>{item.item_radius || "-"}</td>
                            <td>{item.item_thickness ?? "-"}</td>
                            <td>{item.assembly_weight || "-"}</td>
                            <td>{item.assembly_surface_area || "-"}</td> */}
                            <td>{item.remarks || "-"}</td>
                            <td>{item.isAuto ? "Auto" : "Manual"}</td>
                          </tr>
                        ))}
                        {commentsData?.length > 0 && (
                          <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                            <td colSpan="3" className="text-left" style={{ padding: "0 100px" }}>Total</td>
                            <td>{totals.quantity}</td>
                            <td>-</td>
                            <td>-</td>
                            <td>{totals.amount.toFixed(2)}</td>
                            <td>-</td>
                            <td>{totals.discount_amount.toFixed(2)}</td>
                            <td>{totals.taxable_amount.toFixed(2)}</td>
                            <td>-</td>
                            <td>{totals.gst_amount.toFixed(2)}</td>
                            <td>{totals.total_amount.toFixed(2)}</td>
                            <td colSpan="9"></td>
                          </tr>
                        )}
                        {commentsData?.length === 0 ? (
                          <tr>
                            <td colSpan="999">
                              <div className="no-table-data">
                                No Data Found!
                              </div>
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                  <div className="row align-center mt-3 mb-2">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                      <div
                        className="dataTables_info"
                        id="DataTables_Table_0_info"
                        role="status"
                        aria-live="polite"
                      >
                        Showing {Math.min(limit, totalItems)} from {totalItems}{" "}
                        data
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                      <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="DataTables_Table_0_paginate"
                      >
                        <Pagination
                          total={totalItems}
                          itemsPerPage={limit}
                          currentPage={currentPage}
                          onPageChange={(page) => setCurrentPage(page)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-12">
              <div
                className="card h-100"
                style={{ border: "1px solid #e0e0e0" }}
              >
                <div
                  className="card-header"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid var(--primary-clr)",
                    color: "var(--primary-clr)",
                  }}
                >
                  <h6
                    className="mb-0 fw-semibold"
                    style={{ color: "var(--primary-clr)", fontSize: "15px" }}
                  >
                    <i
                      className="fa fa-file-text me-2"
                      style={{ color: "var(--primary-clr)" }}
                    ></i>
                    Terms and Conditions
                  </h6>
                </div>

                <div
                  className="card-body"
                  style={{
                    minHeight: "250px",
                    maxHeight: "350px",
                    overflowY: "auto",
                    fontSize: "14px",
                    padding: "15px",
                    border: "1px solid var(--primary-clr)",
                    borderTop: "0",
                    borderBottomLeftRadius: "7px",
                    borderBottomRightRadius: "7px"
                  }}
                >
                  {data?.termsCondition ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: data.termsCondition }}
                    />
                  ) : (
                    <p className="text-muted">No terms added</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button
                        type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={() =>
                          navigate("/main-store/user/purchase-order-management")
                        }
                      >
                        Back
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewPurOrder;
